import { Events } from '@/services/Events';
import { useConfigStore } from '@/store/config.store';
import { Wedding3DWorld } from '@/littleWedding/Wedding3DWorld';
import { CANVAS_ZOOM_MIN_TOUCH, CANVAS_ZOOM_MIN_DESKTOP, CANVAS_ZOOM_MAX } from '@/config';
import { dataStore } from '@/commons/DataStore';
import { storeToRefs } from 'pinia';
import { onUnmounted } from 'vue';

function useZoomControl() {
    const { isZoomed, zoomLvl3d } = storeToRefs(useConfigStore());
    const { currentSide, fZoom, isMobile } = storeToRefs(useConfigStore());
    function callbackZoom(e: boolean) {
        isZoomed.value = e;
    }
    Events.on('zoomed', callbackZoom);
    onUnmounted(() => {
        Events.off('zoomed', callbackZoom);
    });
    function zoom() {
        if (zoomLvl3d.value > 1) return;
        zoomLvl3d.value += 1;
        Wedding3DWorld.setZoomLvl(zoomLvl3d.value);
    }
    function unZoom() {
        if (zoomLvl3d.value < 1) return;
        zoomLvl3d.value -= 1;
        Wedding3DWorld.setZoomLvl(zoomLvl3d.value);
    }
    function zoomMax() {
        isZoomed.value = true;
        zoomLvl3d.value = 2;
        Wedding3DWorld.setZoomLvl(zoomLvl3d.value);
    }
    function unZoomMax() {
        isZoomed.value = false;
        zoomLvl3d.value = 0;
        Wedding3DWorld.setZoomLvl(zoomLvl3d.value);
    }
    function toggleZoom() {
        if (isZoomed.value) {
            unZoomMax();
            return;
        }
        zoomMax();
    }

    // 2D part
    function zoomHome() {
        const fabricWorld = dataStore.getFabricWorld(currentSide.value);
        if (!fabricWorld.fabricCanvas) {
            return;
        }
        fabricWorld.displayImageFullCanvas();
        fZoom.value = fabricWorld.fabricCanvas.getZoom();
        Events.emit('canvas-zoom-changed', {});
    }

    function zoomIn() {
        const fabricWorld = dataStore.getFabricWorld(currentSide.value);
        if (!fabricWorld.fabricCanvas) {
            return;
        }
        const maxZoom = CANVAS_ZOOM_MAX;
        if (fZoom.value < maxZoom) {
            fZoom.value *= 1.1;
        }
        fabricWorld.zoomInOut(fZoom.value, undefined, maxZoom);
        Events.emit('canvas-zoom-changed', {});
    }

    function zoomOut() {
        const fabricWorld = dataStore.getFabricWorld(currentSide.value);
        if (!fabricWorld.fabricCanvas) {
            return;
        }
        const minZoom = isMobile ? CANVAS_ZOOM_MIN_TOUCH : CANVAS_ZOOM_MIN_DESKTOP;
        if (minZoom < fZoom.value) {
            fZoom.value *= 0.9;
        }
        fabricWorld.zoomInOut(fZoom.value, minZoom);
        Events.emit('canvas-zoom-changed', {});
    }
    return { isZoomed, toggleZoom, zoom, unZoom, zoomMax, unZoomMax, zoomHome, zoomIn, zoomOut };
}

export { useZoomControl };
